// extracted by mini-css-extract-plugin
module.exports = {"back":"GoBackLink_back__3vhl5","img":"GoBackLink_img__2XkXq"};